import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/513fd957/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const InlineNotification = makeShortcode("InlineNotification");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Advanced charts are a powerful way to display complex data sets. While less intuitive than basic charts, the visualizations should still tell a story the user can understand.`}</p>
    </PageDescription>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Advanced charts are not included in the Carbon Charts repository yet. To see our roadmap, make feature requests, or contribute, please go to the carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Alluvial diagram</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Heatmap</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Tree diagram</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Geography with overlays</AnchorLink>
    </AnchorLinks>
    <h2>{`Alluvial diagram`}</h2>
    <p>{`Alluvial diagrams are a type of flow diagram that represents changes in network structure over time.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACgklEQVQoz22SaU+TQRSF/Xl+IMZvaiIBlR0kEFFMlLggglGQrexL2FeFmCYCBtACBQKU0pWWtq8t0EKxW9jaYvs4vBFKopPcuTNncs89M3OuIUYsFiN8GiEcjsg5Gj0jHhP477jIF8FfLCbjsSu4vI7Hz6m4dj6dnUUJHfk4jR5yHA4RPjvi3yEqif8Hj1/i56Qy4WEggkH1C8tSCPNCkJUJDwtKGzqVB91cCM0PH+szu2imd5n7qse04BN4gJVpHyuTbpYmJAK+YEKh13XKWKXEeJXE6Ds7fSV2OkrW6K/Q8alCoueZhZb8TWrTdWRdV1CVqkGRYaTmvo6aVBPv76nZ2pQShHvSCQOvthgstdH/coveEhvNxct0lmgYLpPofm6htcCMIltH/s1mFDkbtBVu0i0anZ/3lm7gdOwkCP17YWZ7dlENulEqftKQbaKleJXJLiszXW46nwh1aQaqUrTkJTVRm6EV6gxUJm/w4Y6eN7dVWEz2KwodJ7Kygdc2oc5KxyMr9QVqWp+uyVetS9eLJkbqMnXkJjXS9tjAlxonw29tdBZtUZOziNXsSBBumw9FRz21D0SkieIsM2V3p6lInqMh08zH1A2qUwWeq6foVrt4Sy3KOif2dfGJ8yFUY3a2XbsJwh3LEY25RpryTCKMtDy0UJ4yS1WmmvZCK30vrCjrnSyO76NTu9BMeanPMFB6Y5XRcgnVZwmv9yBBGNgPy+83N+SRs3rkgJG6VZRtBrRTfmETP8Z5P9pvwj7ft3Fog1iXgwyV2ahOMVKbt4zD5rpi7EiMgPiYiwjuR/E4A+y7QvLa7wnjcwvcGyFwcMxRMHpp6z37KZoZt/BhSN7/Aezc6Fx2boFIAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Alluvial diagram",
            "title": "Alluvial diagram",
            "src": "/static/b05d259ba5784549fa0fcce74fe819d1/3cbba/charts-adv-alluvial.png",
            "srcSet": ["/static/b05d259ba5784549fa0fcce74fe819d1/7fc1e/charts-adv-alluvial.png 288w", "/static/b05d259ba5784549fa0fcce74fe819d1/a5df1/charts-adv-alluvial.png 576w", "/static/b05d259ba5784549fa0fcce74fe819d1/3cbba/charts-adv-alluvial.png 1152w", "/static/b05d259ba5784549fa0fcce74fe819d1/0b124/charts-adv-alluvial.png 1728w", "/static/b05d259ba5784549fa0fcce74fe819d1/0c3f5/charts-adv-alluvial.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of an alluvial diagram</Caption>
      </Column>
    </Row>
    <h2>{`Heatmap`}</h2>
    <p>{`A heat map is a graphical representation of data where individual values contained in a matrix are represented as colors.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACU0lEQVQoz6WS20/SYRjH/Qe66L9oddE/0E0XXdVtKzusi7pytbkyc62l5WrljNKZTG88dRjMDAQ1Dkp4IEEDRERAQA5SCfQDD3EQ4dMPHGZ11Xq2533e5323z77v932qiohRLJLP58nkdshkc2TFmhVrfrfAbqH4WxYO5MHzYrFMoqq0FMQmHkuQFmLktjfIpbfJbG+WbviXKEGrKuT15A+0rjgTgS3Mq6lyGv0pDL4kOo/AqCuBKZDEGd3kcyjFbEDA5BfQLCeY9ifLosoKK8DYRhqJapEXKgc6axC9LchD5RJ1MgeXeuycllqp7nFwoW+RByo3BnuI/ik/F3sd3FF4yvbsAQt7m+xalMitelx19zjVZuFEh51OpZ0hjQ39vB+LO8qINczgXBiJzsflPgfX5S7uq720G1bJF/5QmNrKoDa6GBx3ck1q4krHDI3vHLSol6iVL1Hd56RT58W8EED2aZXWyQhNmgBnumzUyJfZ2VdYAcaTKLuGGOpW0D1sRape4Omom8djXhpVHuoVbtr0PnpnI2jGLMT7X6HvV3PypZ2rb1y/gBUz14Q0DaJfta/tHH1k4kiziQ5RkWouiNwcQmYJ834+jEL8nOmBYb6fO4/mRiPHn9s427P4NzCaytD8wUeD0sPh2xMcujlO+6gTrXkFicbD3WEPLR+8PBP9G9Qu8M1g5K3MSFWNlmPNM+Ty+08uTxCC6OFH9zp61zqt40GeaAMo7F/Rif2A5QsSQ4hJT4xYTGA5IjDrT4hjFqNpZAXpVLg83PuDXfHxf6PE+QkOcAI71hU4+AAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Horizontal bar chart",
            "title": "Horizontal bar chart",
            "src": "/static/7e205919a6bd7d99b6584f25f7895e03/3cbba/charts-adv-heatmap.png",
            "srcSet": ["/static/7e205919a6bd7d99b6584f25f7895e03/7fc1e/charts-adv-heatmap.png 288w", "/static/7e205919a6bd7d99b6584f25f7895e03/a5df1/charts-adv-heatmap.png 576w", "/static/7e205919a6bd7d99b6584f25f7895e03/3cbba/charts-adv-heatmap.png 1152w", "/static/7e205919a6bd7d99b6584f25f7895e03/0b124/charts-adv-heatmap.png 1728w", "/static/7e205919a6bd7d99b6584f25f7895e03/0c3f5/charts-adv-heatmap.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2>{`Tree diagram`}</h2>
    <p>{`A tree diagram visually represents a hierarchy in a tree-like structure.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABcElEQVQoz32T6Y6CQBCEfQYFD1QQvJCBYT1AI3iE93+nWqqTZtXE/dEZMtPzdVX30HNdF8PhsAvHcTAYDOQ78AN4niff4/FYVuZHUYQ4jrFer7FcLjGZTKCcniYxCNrtEhRFgTAMcTlfcDgcBOr7fpcXhhGMMQLdbDaYTqd/QH6MRiPZ5Ia1Oe73O1arFc5lKUCqZjDXcR3MZjPsf/Zt8Z2AmcvzDkgFPKSqPM9R1/UbcLFYIMsyzOdzuei1Fk2SIE1TuUfb6rSzrH1jPxjsGUFUk7SXm6aRnqlaFn48Hjgej1KUedzvfQ6F9gkXe21Cv98XFc/nU4A8Y3tolQqpnL3kPVGoQF1pn8EETeJAqJIrgVR3vV5xOp3e1HVTfn0yrFhVldhVqCpVu6lJBWatlfgKZHUm3G43AXIIVPvaFl40iRFlapst+ApkgioMguDtjSnQZhZlUUpx2v/X8na7Rdk+F8J0SK9A/VM4IK6ff8ovRkcqqeifSoIAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tree diagram, organic view",
            "title": "Tree diagram, organic view",
            "src": "/static/0fae5c2239e80d5f715c056c6204e336/3cbba/charts-adv-treediagram.png",
            "srcSet": ["/static/0fae5c2239e80d5f715c056c6204e336/7fc1e/charts-adv-treediagram.png 288w", "/static/0fae5c2239e80d5f715c056c6204e336/a5df1/charts-adv-treediagram.png 576w", "/static/0fae5c2239e80d5f715c056c6204e336/3cbba/charts-adv-treediagram.png 1152w", "/static/0fae5c2239e80d5f715c056c6204e336/0b124/charts-adv-treediagram.png 1728w", "/static/0fae5c2239e80d5f715c056c6204e336/0c3f5/charts-adv-treediagram.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Tree diagram, node view vs. list view</Caption>
      </Column>
    </Row>
    <h2>{`Geography with overlays`}</h2>
    <h3>{`Choropleth map`}</h3>
    <p>{`A choropleth map uses differences in shading, coloring, or the placement of symbols within predefined areas to indicate the average values of a property or quantity in those areas.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAACHElEQVQoz22TP0xTURTGG2McoNLy3n33/el7tY+mtLSVasFEwVShEYkBahQTdEAMqHFwMDhoHExUojM6CIvGQTDGwYXVxU2MA4mri3FzxPXnu6/pHxqGk3Nz3znf+b7z3RcxDIOkl6RYGCSTyZDNZnFdFyklpmkFobLZFlYzS2nieR6O44R3qidiSAM3keR48SQpP4Vt29iWgyEFwtDCpjp4HVhIvflNhaq3LKsFWD8YCKGj63pQYCHMGK6TYqR4kYxfqINJK6zrcwdw7RR+IhueFSEFVB9qEmkcQmDT4M36Jk+Xtrh6+jkjR2cCSQkc28X3spT6zvB48isvpnd4efk3N0ZX0USsuYaQYQNQSbNsk7Oj5/lwH1aubVMtX0c34qTTGVZufWZ97i9v53d5Pw9PLnwjkyzRTqjJUIUVTFGS1T5+bv/hy6dfDOcm6Il3U6su8uzuBmv3dthY/sfrGiwMv0NaIiTSYBcCdjooDJ3Zc7eZGJ8irnfREztMtTJNPlti8cojHt5c40Fti7I/Ra+I7pErzaYpraUq1w4eOsDczB02V78zWBgirkVZmF2mmCsHQ7rxj6Tp94+RCvbazs6UnaYo6YHkXi3GqRMVPr76QX86jy7iXJpcYqhYCZ+MctxNeHhuMgTZV3I7sKZpDOTyjI2NE412BUNsDKGelta2Hhm4n8Bz/D29HTtsAassApDWndy3rv7HtHr+A8blSCvc3p5UAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Choropleth map",
            "title": "Choropleth map",
            "src": "/static/d31d564171a45b46fa99430952631b33/3cbba/charts-adv-choropleth.png",
            "srcSet": ["/static/d31d564171a45b46fa99430952631b33/7fc1e/charts-adv-choropleth.png 288w", "/static/d31d564171a45b46fa99430952631b33/a5df1/charts-adv-choropleth.png 576w", "/static/d31d564171a45b46fa99430952631b33/3cbba/charts-adv-choropleth.png 1152w", "/static/d31d564171a45b46fa99430952631b33/0b124/charts-adv-choropleth.png 1728w", "/static/d31d564171a45b46fa99430952631b33/0c3f5/charts-adv-choropleth.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a choropleth map</Caption>
      </Column>
    </Row>
    <h3>{`Proportional symbol`}</h3>
    <p>{`Symbols driven by data are overlayed in geographical regions. A common symbol used is a bubble with the area of the circle proportional to its value in the dataset.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABU0lEQVQoz31Ty07DMBDM/1/5Be7wAxw5cOEIQhVQVS2iSew4aZrErwzeDbZMCqy08Ws9uzPeFAg2jiOEEFBKsTdNA+89os3zzJ7P43qaJlhr07qgjzEGfd8zcHQy51wKjGBrI7A8rlgHUWXOO5Rliaqq0gXn/HLG88VpvU5Y5BTatoWUEuWxxna7Rdd1fDGkoXAGJzY08lyb73NcVkjZtJ5QlQL7VwkhBQN6P0N8DNg8ygBmExg5Jcq1TRrmItefJ9xcbSDqBtpo3ru73uP+9gBjTUiqGWwcNJ4fBJzxPx6rWGfQk8XuRcEam/ZPih7JMhhRJteThqomRAkvKOdVkg3DACV6pux81M5wDMlD66htjlGs22EBXvprtwmU7EJJHs9MM7WLs3h/qjCe9f+U48i9BZcA2jo0sI56hdpmh8Nbk5IkwLwHc9pLn834ncH851/0Bc3iX4fuzxApAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Proportional symbol",
            "title": "Proportional symbol",
            "src": "/static/e8ff96a80f4b27b489a20e4cecfd022e/3cbba/charts-adv-proportion.png",
            "srcSet": ["/static/e8ff96a80f4b27b489a20e4cecfd022e/7fc1e/charts-adv-proportion.png 288w", "/static/e8ff96a80f4b27b489a20e4cecfd022e/a5df1/charts-adv-proportion.png 576w", "/static/e8ff96a80f4b27b489a20e4cecfd022e/3cbba/charts-adv-proportion.png 1152w", "/static/e8ff96a80f4b27b489a20e4cecfd022e/0b124/charts-adv-proportion.png 1728w", "/static/e8ff96a80f4b27b489a20e4cecfd022e/0c3f5/charts-adv-proportion.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a proportional symbol</Caption>
      </Column>
    </Row>
    <h3>{`Connecting lines`}</h3>
    <p>{`Connection maps display points on a map connected by straight or curved lines.`}</p>
    <p>{`Connection maps are most useful when showing connections and relationships geographically. They can also be used to display map routes through a single chain of links.`}</p>
    <p>{`Connection maps are particularly powerful when revealing spatial patterns through the distribution of connections or by how concentrated connections are on a map.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABKklEQVQoz3VTi5KDIAz0/z/T6XjXqSLgCxTcY1Eo1SszkaBks5vECmFN04Tn84mu66K1bQvvPdLa9z1a6afzsixY1zWfKz6cczDGxA/JeGG1awZ+A6Ukx85Y3smAyUlBvGCtRdM0kem2rTmIRr+0a3xVSpBSQogOfS9Q1zWU1EcQDiAyXmYb9i0k2s5kbwUfDJmdUoXoIV4KP48WolUwo8MgF2g1wiwsxwZrTuDgl7XNNSxpKzHh9xGa85Ih0GKzewDWGPQYE7IcZEe2So63ZlXXF2RqrYHzQaoLzIMkSvsAOxvnnb9NwQ3wOADzPEP2QwxKjSJYWZ4IenY4M7xKTj4BtNZ5bNK8pUWfTeS9r5LLnWzILK00ImUTqaJMkhn+90eUM3ZV8O3M/Q8WR2K3oCmydwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Connecting lines on a spatial map",
            "title": "Connecting lines on a spatial map",
            "src": "/static/7fa540e390ac5debf9e387563f993c1f/3cbba/charts-adv-connecting.png",
            "srcSet": ["/static/7fa540e390ac5debf9e387563f993c1f/7fc1e/charts-adv-connecting.png 288w", "/static/7fa540e390ac5debf9e387563f993c1f/a5df1/charts-adv-connecting.png 576w", "/static/7fa540e390ac5debf9e387563f993c1f/3cbba/charts-adv-connecting.png 1152w", "/static/7fa540e390ac5debf9e387563f993c1f/0b124/charts-adv-connecting.png 1728w", "/static/7fa540e390ac5debf9e387563f993c1f/0c3f5/charts-adv-connecting.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">Example of a map with connecting lines</Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      